import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
// import { useIntl } from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Badge } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.grey[50]
  },
  icon: {
    minWidth: '36px'
  },
  redBadge: {
    backgroundColor: 'red',
    color: 'white',
    marginRight: '10px'
  }
}));

const textTypographyProps = { variant: 'body2' };

const NavigationItem = ({
  text,
  Icon,
  fontSize = 'small',
  visible = () => true,
  classes = {},
  onClick,
  isShowBadg = false,
  feedbackCount = 0,
  isFetching
}) => {
  const localClasses = useStyles();
  // Translate once the texts for the navigation texts are translated. Annoying
  // with all errors in console for now.
  // const { formatMessage } = useIntl();
  // const translatedLabel = formatMessage({ id: label });
  console.log(typeof feedbackCount, 'feedbackCount');

  if (!visible()) {
    return null;
  }
  return (
    <ListItem
      button
      className={cx(localClasses.root, classes.root)}
      onClick={onClick}
    >
      <ListItemIcon className={cx(localClasses.icon, classes.icon)}>
        <Icon fontSize={fontSize} />
      </ListItemIcon>
      <ListItemText primaryTypographyProps={textTypographyProps}>
        {text}
      </ListItemText>
      {isShowBadg &&
        !isFetching &&
        (feedbackCount !== 0 || feedbackCount !== undefined) && (
          <Badge
            classes={{ badge: localClasses.redBadge }}
            badgeContent={feedbackCount}
            color="primary"
          >
            <span />
          </Badge>
        )}
    </ListItem>
  );
};

NavigationItem.propTypes = {
  text: PropTypes.string.isRequired,
  Icon: PropTypes.object,
  fontSize: PropTypes.string,
  visible: PropTypes.func,
  classes: PropTypes.shape({
    root: PropTypes.string,
    icon: PropTypes.string
  }),
  onClick: PropTypes.func.isRequired
};

export default NavigationItem;
